<ion-menu contentId="main-content" swipeGesture="false" [attr.aria-label]="'main-menu-component.aria.menu' | translate">
  <div class="menu-header viva-page">
    <h3 *ngIf="profile">{{profile.firstName}} {{profile.lastName}}</h3>

    <h4 class="uat-environment" *ngIf="!isProduction">UAT</h4>
    <small class="uat-environment" *ngIf="!isProduction && installSource">{{installSource}}</small>
    <small>{{ 'main-menu-component.items.version' | translate }} {{versionNumber}}</small>
  </div>
  <ion-content class="ion-padding menu-border">
    <ion-list>

      <ion-item class="menu-item" (click)="myProfile()" [disabled]="!isOnline">
        <ion-icon name="person-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.profile' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="dimensions()" *ngIf="showProfileDimensionsMenu" [disabled]="!isOnline">
        <ion-icon name="resize-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.dimensions' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="linkExternalLogin()" *ngIf="enableExternalLogin" [disabled]="!isOnline">
        <ion-icon name="link-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.link-account' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
      
      <ion-item class="menu-item" (click)="openRewards()" *ngIf="hasRewardsPartner" [disabled]="!isOnline">
        <ion-icon name="gift-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.rewards' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="changePassword()" *ngIf="isLocalAccount" [disabled]="!isOnline">
        <ion-icon name="lock-closed-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.password' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="changeEmail()" *ngIf="isLocalAccount" [disabled]="!isOnline">
        <ion-icon name="mail-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.emailchange' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <div class="menu-spacer"></div>

      <ion-item class="menu-item" (click)="manageSubscription()" *ngIf="enableSubscriptions" [disabled]="!isOnline">
        <ion-icon name="card-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.manage-subscription' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="startOptInAndOpenWhatsApp()" *ngIf="whatsappEnabled" [disabled]="!isOnline">
        <ion-icon name="logo-whatsapp" slot="start" class="menu-icon menu-icon-whatsapp"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.whatsapp-opt-in' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="vivaScoreLite()" *ngIf="scanFriendAllowed" [disabled]="!isOnline">
        <ion-icon name="scan-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.viva-lite' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="skinDemoAllowed" class="menu-item" (click)="skinConditionDemo()" [disabled]="!isOnline">
        <ion-icon name="body-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.skin-condition-demo' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="telematics()" *ngIf="telematicsAllowed" [disabled]="!isOnline">
        <ion-icon name="car-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.telematics' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="completedAssessments()" [disabled]="!isOnline">
        <ion-icon name="document-text-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.completed-assessments' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="deviceHelpPage()">
        <ion-icon name="watch-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.device-help' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
      
      <ion-item class="menu-item" (click)="gotoHelpCenter()" [disabled]="!isOnline">
        <ion-icon name="information-circle-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.help-center' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <div class="menu-spacer"></div>
      
      <ion-item class="menu-item" (click)="contactUs()" [disabled]="!isOnline">
        <ion-icon name="chatbubble-ellipses-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.contact-us' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
      <ion-item class="menu-item" (click)="openUrl(privacyPolicyUrl)" [disabled]="!isOnline">
        <ion-icon name="shield-checkmark-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.privacy-policy' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="openUrl(termsOfUseURL)" [disabled]="!isOnline">
        <ion-icon name="clipboard-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.terms-conditions' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <div class="menu-spacer"></div>

      <ion-item class="menu-item" (click)="deleteAccount()" [disabled]="!isOnline">
        <ion-icon name="trash-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.delete-account' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="menu-item" (click)="logout()" [disabled]="!isOnline">
        <ion-icon name="log-out-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.logout' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <div *ngIf="demoVisible" class="menu-spacer"></div>

      <ion-item *ngIf="demoVisible" class="menu-item" (click)="visionWeb()" [disabled]="!isOnline">
        <ion-icon name="eye-outline" slot="start" class="menu-icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <h3>{{ 'main-menu-component.items.vision-web-demo' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

    </ion-list>

  </ion-content>
</ion-menu>